import React from 'react';
import { CONSTANTS } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
import { ArrowRight } from 'lucide-react';
export const FinalCTASection: React.FC = () => {
  const handleBuyClick = () => {
    window.open(CONSTANTS.PAYMENT_LINK, '_blank');
  };
  return <section className="py-20 bg-blue-900 text-white relative overflow-hidden" data-id="element-68">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-69">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-70"></div>
        <div className="absolute bottom-0 right-0 w-full h-1/2 bg-gradient-to-t from-blue-950 to-transparent" data-id="element-71"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-72">
        <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-73">
          ¿Listo para transformar tus clases de gimnasia artística?
        </h2>
        <p className="text-xl text-blue-200 mb-10 max-w-2xl mx-auto" data-id="element-74">
          No pierdas más tiempo planificando desde cero. Obtené el sistema
          completo hoy mismo y empezá a disfrutar de enseñar.
        </p>

        <div className="bg-blue-800/50 border border-blue-700 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto backdrop-blur-sm mb-10" data-id="element-75">
          <div className="flex flex-col items-center justify-center space-y-4 mb-6" data-id="element-76">
            <span className="text-red-400 font-bold uppercase tracking-wider text-sm" data-id="element-77">
              La oferta con 5 bonos termina en:
            </span>
            <CountdownTimer size="lg" theme="dark" data-id="element-78" />
          </div>

          <button onClick={handleBuyClick} className="w-full bg-green-500 hover:bg-green-400 text-white font-black text-2xl py-5 px-8 rounded-xl shadow-lg hover:shadow-green-500/30 transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center" data-id="element-79">
            COMPRAR AHORA POR {CONSTANTS.PRICES.SALE}
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-80" />
          </button>
          <p className="mt-4 text-sm text-blue-300" data-id="element-81">
            Pago único • Acceso de por vida • Garantía de 45 días
          </p>
        </div>
      </div>
    </section>;
};